class ME_BookSlider {
    constructor() {
        this.bookSlider();
    }

    bookSlider() {
        let examsSlider = document.querySelectorAll('.exams-slider');
        if (examsSlider.length > 0) {
            for (let i = 0; i < examsSlider.length; i++) {
                let examSliderList = examsSlider[i].querySelector('.exams-slider-list');
                let examsSliderItems = examSliderList.querySelectorAll('li');
                let examsSliderItemWidth;
                let prev = examsSlider[i].querySelector('.prev');
                let next = examsSlider[i].querySelector('.next');
                let mediaMobile = window.matchMedia('(max-width: 600px)');
                let currentSlide = 0;

                function countQuery() {
                    if (mediaMobile.matches) {
                        examsSliderItemWidth = examSliderList.querySelector('li').getBoundingClientRect().width;
                        return 1;
                    } else {
                        examsSliderItemWidth = examSliderList.querySelector('li').getBoundingClientRect().width + 15;
                        return 3;
                    }
                }

                function moveSlide() {
                    examSliderList.style.transform = `translateX(${-examsSliderItemWidth * currentSlide}px)`;
                }

                next.addEventListener('click', function (e) {
                    e.preventDefault();
                    currentSlide++;
                    if (currentSlide > examsSliderItems.length - countQuery()) {
                        currentSlide = 0;
                    }
                    moveSlide()
                })


                prev.addEventListener('click', function (e) {
                    e.preventDefault();
                    currentSlide--;
                    if (currentSlide < 0) {
                        currentSlide = examsSliderItems.length - countQuery();
                    }
                    moveSlide()
                })
            }
        }
    }
}
